import React, { useEffect, useState } from 'react';

function ImageSize(props) {

    const {
        titleWidth,
        titleHeight,
    } = props.attributes;

    const [size, setSize] = useState({ width: 0, height: 0 });

    /* useEffect(() => {
        const img = new Image();
        img.onload = function () {
            setSize({ width: this.naturalWidth, height: this.naturalHeight });
        };
        img.src = props.src;
    }, [props.src]); // добавлено props.src */

    useEffect(() => {
        const img = new Image();
        const srcWithTimestamp = `${props.src}?t=${new Date().getTime()}`;
        img.src = srcWithTimestamp;

        if (img.complete) {
            setSize({ width: img.naturalWidth, height: img.naturalHeight });
        } else {
            img.onload = function () {
                setSize({ width: this.naturalWidth, height: this.naturalHeight });
            };
        }
    }, [props.src]);

    return (
        <div>
            <p>{titleWidth}: {size.width}</p>
            <p>{titleHeight}: {size.height}</p>
        </div>
    );
}

export default ImageSize;
